import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectReferenceAttributeResponse} from '../models/project-reference-attribute-response';
import {ProjectReferenceAttributesUpdateRequest} from '../models/project-reference-attribute-update-request';

export interface ProjectReferenceAttributeService {
    listAttributes(refId: number): Observable<ProjectReferenceAttributeResponse>;
    saveAttributes(refId: number, attributes: ProjectReferenceAttributesUpdateRequest): Observable<ProjectReferenceAttributeResponse>
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceAttributeServiceImpl implements ProjectReferenceAttributeService {
    protected http = inject(HttpClient);


    listAttributes(refId: number): Observable<ProjectReferenceAttributeResponse> {
        return this.http.get<ProjectReferenceAttributeResponse>(`/api/v1/project-references/${refId}/attributes`);
    }

    saveAttributes(refId: number, attributes: ProjectReferenceAttributesUpdateRequest): Observable<ProjectReferenceAttributeResponse> {
        return this.http.post<ProjectReferenceAttributeResponse>(`/api/v1/project-references/${refId}/attributes`, {
            ...attributes
        });
    }
}
